import p1 from "./Pimg/Beef Bacon - Add - on Only N2,100.jpg"
import p2 from "./Pimg/Big King XXL Meal - Medium N15,850.jpg"
import p3 from "./Pimg/Big Whizz Meal N6,400.jpg"
import p4 from "./Pimg/Cheese - Add - on Only N1,000.jpg"
import p5 from "./Pimg/Cheeseburger Meal - Large N8,200.jpg"
import p6 from "./Pimg/Cheeseburger Meal - Medium N7,100.jpg"
import p7 from "./Pimg/Cheeseburger Meal - Regular N6,000.jpg"
import p8 from "./Pimg/Cheeseburger N3,900.jpg"
import p9 from "./Pimg/Chicken Burger Meal - Large N7,600.jpg"
import p10 from "./Pimg/Chicken Burger Meal - Medium N6,500.jpg"
import p11 from "./Pimg/Chicken Burger Meal - Regular N5,400.jpg"
import p12 from "./Pimg/Chicken Burger N4,300.jpg"
import p13 from "./Pimg/Chicken Royal Meal - Large N10,500.jpg"
import p14 from "./Pimg/Chicken Royale Meal - Medium N9,400.jpg"
import p15 from "./Pimg/Chicken Wings 3 pcs N6,000.jpg"
import p16 from "./Pimg/Chicken Wings 4 pcs N7,100.jpg"
import p17 from "./Pimg/Chicken Wings 6 pcs N9,300.jpg"
import p18 from "./Pimg/Chop Up N6,000.jpg"
import p19 from "./Pimg/Coca-Cola 35cl PET N1,200.jpg"
import p20 from "./Pimg/Coca-Cola 50cl PET N1,500.jpg"
import p21 from "./Pimg/Crispy Chicken Meal - Large N9,900.jpg"
import p22 from "./Pimg/Crispy Chicken N5,600.jpg"
import p23 from "./Pimg/Double Cheeseburger Meal - Large N10,500.jpg"
import p24 from "./Pimg/Double Cheeseburger Meal - Medium N9,400.jpg"
import p25 from "./Pimg/Double Cheeseburger N7,200.jpg"
import p26 from "./Pimg/Double Streakhouse Meal - Medium N15,850.jpg"
import p27 from "./Pimg/Double Whopper Meal - Medium N14,750.jpg"
import p28 from "./Pimg/Double Whopper Meal - Regular N14,650.jpg"
import p29 from "./Pimg/Double Whopper N12,670.jpg"
import p30 from "./Pimg/Eva Water 75cl PET N1,200.jpg"
import p31 from "./Pimg/Fanta Orange 35cl PET N1,200.jpg"
import p32 from "./Pimg/Fanta Orange 50cl PET N1,500.jpg"
import p33 from "./Pimg/Fire-Up N4,500.jpg"
import p34 from "./Pimg/Fries Large N4,300.jpg"
import p35 from "./Pimg/Fries Medium N3,800.jpg"
import p36 from "./Pimg/Fries Regular N3,200.jpg"
import p37 from "./Pimg/Hamburger Meal - Large N7,600.jpg"
import p38 from "./Pimg/Hamburger Meal - Medium N6,500.jpg"
import p39 from "./Pimg/Hamburger Meal - Regular N5,400.jpg"
import p40 from "./Pimg/Hamburger N3,300.jpg"
import p41 from "./Pimg/Kids Meal Cheeseburger N8,200.jpg"
import p42 from "./Pimg/Kids Meal Chicken Burger N7,600.jpg"
import p43 from "./Pimg/Kids Meal Hamburger N7,600.jpg"
import p44 from "./Pimg/Kids Meal Nuggets N7,600.jpg"
import p45 from "./Pimg/King Nuggets 4 pcs N4,300.jpg"
import p46 from "./Pimg/King Nuggets 6 pcs N5,400.jpg"
import p47 from "./Pimg/King Nuggets 4 pcs N4,300.jpg"
import p48 from "./Pimg/King Nuggets 6 pcs N5,400.jpg"
import p49 from "./Pimg/Monster Original 440ml N3,200.jpg"
import p50 from "./Pimg/Monster Zero Ultra 440ml N3,200.jpg"
import p51 from "./Pimg/Nuggets 9 pcs N7,600.jpg"
import p52 from "./Pimg/Plantain Cubes - Regular N3,200.jpg"
import p53 from "./Pimg/Plantain Large N3,800.jpg"
import p54 from "./Pimg/Schweppes Chapman 40cl N2,100.jpg"
import p55 from "./Pimg/Schweppes Mojito 40cl N2,100.jpg"
import p56 from "./Pimg/Schweppes Pineapple 40cl N2,100.jpg"
import p57 from "./Pimg/Small Chopzz Combo N3,900.jpg"
import p58 from "./Pimg/Small Chopzz N3,100.jpg"
import p59 from "./Pimg/Spicy Chicken Royale Meal - Large N12,300.jpg"
import p60 from "./Pimg/Spicy Chicken Royale Meal - Medium N10,200.jpg"
import p61 from "./Pimg/Spirit Lemon 35cl PET N1,200.jpg"
import p62 from "./Pimg/Spirit lemon 50cl PET N1,500.jpg"
import p63 from "./Pimg/Sweet Potato - Regular N3,200.jpg"
import p64 from "./Pimg/Sweet Potato Large N3,800.jpg"
import p65 from "./Pimg/The Beef Gourmet Meal N24,000.jpg"
import p66 from "./Pimg/The Beef Gourmet N19,600.jpg"
import p67 from "./Pimg/The Big Deal N19,500.jpg"
import p68 from "./Pimg/The Big King Chicken Meal - Large N12,200.jpg"
import p69 from "./Pimg/The Big King Chicken Meal - Medium 10,200.jpg"
import p70 from "./Pimg/The Big King Meal - Regular N9,000.jpg"
import p71 from "./Pimg/The Big King Meal - Large N12,200.jpg"
import p72 from "./Pimg/The Big King Meal - Medium N10,200.jpg"
import p73 from "./Pimg/The Big King Meal - Regular N9,000.jpg"
import p74 from "./Pimg/The Big King XXL Meal- Regular N14,750.jpg"
import p75 from "./Pimg/The Chicken Gourmet Meal N24,000.jpg"
import p76 from "./Pimg/The Chicken Gourmet N19,600.jpg"
import p77 from "./Pimg/The Double Streakhouse Meal - Large N16,950.jpg"
import p78 from "./Pimg/The Double Whopper Meal - Large N14,850.jpg"
import p79 from "./Pimg/The Gourmet Fries N6,500.jpg"
import p80 from "./Pimg/The King Chicken Fillet Meal - Medium N12,550.jpg"
import p81 from "./Pimg/The King Chicken Fillet N9,800.jpg"
import p82 from "./Pimg/The Meat Lover Gourmet Meal N24,100.jpg"
import p83 from "./Pimg/The Meat Lover Gourmet N20,700.jpg"
import p84 from "./Pimg/The Steakhouse Meal - Large N14,750.jpg"
import p85 from "./Pimg/The Steakhouse Meal - Medium N14,650.jpg"
import p86 from "./Pimg/The Steakhouse N10,350.jpg"
import p87 from "./Pimg/The Whopper Meal - Large  N12,800.jpg"
import p88 from "./Pimg/The Whopper Meal - Medium N10,700.jpg"
import p89 from "./Pimg/The Whopper Meal - Regular N9,600.jpg"
import p90 from "./Pimg/The double Steakhouse Meal -Regular N14,750.jpg"
import p91 from "./Pimg/Whopper Junior Meal - Large N9,300.jpg"
import p92 from "./Pimg/Whopper junior N5,400.jpg"
import p93 from "./Pimg/Yam Fries Large N3,800.jpg"
import p94 from "./Pimg/Yam Fries Regular N3,200.jpg"







const products = [

 
    
    {
      id: 2,
      name: "Big King XXL Meal - Medium",
      category: "signature",
      price: 15850,
      image: p2 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
   
    {
      id: 5,
      name: "Cheeseburger Meal - Large",
      category: "classic",
      price: 8200,
      image: p5 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 6,
      name: "Cheeseburger Meal - Medium",
      category: "classic",
      price: 7100,
      image: p6 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    
    {
      id: 7,
      name: "Cheeseburger Meal - Regular",
      category: "classic",
      price: 6000,
      image: p7 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 8,
      name: "Cheeseburger",
      category: "value",
      price: 3900,
      image: p8 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 9,
      name: "Chicken Burger Meal - Large",
      category: "value",
      price: 7600,
      image: p9 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 10,
      name: "Chicken Burger Meal - Medium",
      category: "value",
      price: 6500,
      image: p10 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 11,
      name: "Chicken Burger Meal - Regular",
      category: "value",
      price: 5400,
      image: p11 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 12,
      name: "Chicken Burger",
      category: "value",
      price: 4300,
      image: p12 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 13,
      name: "Chicken Royal Meal - Large",
      category: "classic",
      price: 10500,
      image: p13 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 14,
      name: "Chicken Royale Meal - Medium",
      category: "classic",
      price: 9400,
      image: p14 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 15,
      name: "Chicken Wings 3 pcs",
      category: "sides",
      price: 6000,
      image: p15 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 16,
      name: "Chicken Wings 4 pcs",
      category: "sides",
      price: 7100,
      image: p16 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 17,
      name: "Chicken Wings 6 pcs",
      category: "sides",
      price: 9300,
      image: p17 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 18,
      name: "Chop Up",
      category: "xclusive deals",
      price: 6300,
      image: p18 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 19,
      name: "Coca-Cola 35cl PET",
      category: "drinks",
      price: 1200,
      image: p19 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 20,
      name: "Coca-Cola 50cl PET",
      category: "drinks",
      price: 1500,
      image: p20 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 21,
      name: "Crispy Chicken Meal - Large",
      category: "classic",
      price: 9900,
      image: p21 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 22,
      name: "Crispy Chicken",
      category: "sides",
      price: 5600,
      image: p22 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 23,
      name: "Double Cheeseburger Meal - Large",
      category: "classic",
      price: 10500,
      image: p23 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 24,
      name: "Double Cheeseburger Meal - Medium",
      category: "classic",
      price: 9400,
      image: p24 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 25,
      name: "Double Cheeseburger",
      category: "value",
      price: 7200,
      image: p25 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 26,
      name: "Double Streakhouse Meal - Medium",
      category: "signature",
      price: 15850,
      image: p26 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 27,
      name: "Double Whopper Meal - Medium",
      category: "classic",
      price: 14750,
      image: p27 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 28,
      name: "Double Whopper Meal - Regular",
      category: "classic",
      price: 14650,
      image: p28 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 29,
      name: "Double Whopper ",
      category: "classic",
      price: 12700,
      image: p29 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 30,
      name: "Eva Water 75cl PET",
      category: "drinks",
      price: 1200,
      image: p30 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 31,
      name: "Fanta Orange 35cl PET",
      category: "drinks",
      price: 1200,
      image: p31 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 32,
      name: "Fanta Orange 50cl PET",
      category: "drinks",
      price: 1500,
      image: p32 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 33,
      name: "Fire-Up",
      category: "value",
      price: 4500,
      image: p33 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 34,
      name: "Fries Large",
      category: "sides",
      price: 4300,
      image: p34 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 35,
      name: "Fries Medium ",
      category: "sides",
      price: 3800,
      image: p35 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 36,
      name: "Fries Regular ",
      category: "sides",
      price: 3200,
      image: p36 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 1,
      name: "Beef Bacon - Add - on Only",
      category: "value",
      price: 2100,
      image: p1 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 37,
      name: "Hamburger Meal - Large",
      category: "value",
      price: 7600,
      image: p37 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
   
    {
      id: 38,
      name: "Hamburger Meal - Medium",
      category: "value",
      price: 6500,
      image: p38 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 39,
      name: "Hamburger Meal - Regular",
      category: "value",
      price: 5400,
      image: p39 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 40,
      name: "Hamburger N3,300",
      category: "classic",
      price: 2300,
      image: p40 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 41,
      name: "Kids Meal Cheeseburger",
      category: "kids",
      price: 8200,
      image: p41 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 42,
      name: "Kids Meal Chicken Burger",
      category: "kids",
      price: 7600,
      image: p42 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 43,
      name: "Kids Meal Hamburger",
      category: "kids",
      price: 7600,
      image: p43 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 44,
      name: "Kids Meal Nuggets",
      category: "kids",
      price: 7600,
      image: p44 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 45,
      name: "King Nuggets 4 pcs",
      category: "sides",
      price: 4300,
      image: p45 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 46,
      name: "King Nuggets 6 pcs",
      category: "sides",
      price: 5400,
      image: p46 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 47,
      name: "King Nuggets 4 pcs",
      category: "sides",
      price: 4300,
      image: p47 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 48,
      name: "King Nuggets 6 pcs",
      category: "sides",
      price: 5400,
      image: p48 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 49,
      name: "Monster Original 440ml",
      category: "drinks",
      price: 3200,
      image: p49 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 50,
      name: "Monster Zero Ultra 440ml",
      category: "drinks",
      price: 3200,
      image: p50 ,
      shopId: "shop008",
      shopName: "Burger King",
      
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
    {
      id: 51,
      name: "Nuggets 9 pcs",
      category: "sides",
      price: 7600,
      image: p51 ,
      shopId: "shop008",
      shopName: "Burger King",
        vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
    },
     
       {
        id: 52,
        name: "Plantain Cubes - Regular",
        category: "sides",
        price: 3200,
        image: p52 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 53,
        name: "Plantain Large",
        category: "sides",
        price: 3800,
        image: p53 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 54,
        name: "Schweppes Chapman 40cl",
        category: "drinks",
        price: 2100,
        image: p54 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 55,
        name: "Schweppes Mojito 40cl",
        category: "drinks",
        price: 2100,
        image: p55 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 56,
        name: "Schweppes Pineapple 40cl",
        category: "drinks",
        price: 2100,
        image: p56 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 57,
        name: "Small Chopzz Combo",
        category: "small chopzz",
        price: 3900,
        image: p57 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 58,
        name: "Small Chopzz",
        category: "small chopzz",
        price: 3100,
        image: p58 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 3,
        name: "Big Whizz Meal",
        category: "classic",
        price: 6400,
        image: p3 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 4,
        name: "Cheese - Add - on Only",
        category: "sides",
        price: 1000,
        image: p4 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 59,
        name: "Spicy Chicken Royale Meal - Large",
        category: "classic",
        price: 12300,
        image: p59 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
  
      {
        id: 60,
        name: "Spicy Chicken Royale Meal - Medium",
        category: "classic",
        price: 10200,
        image: p60 ,
        shopId: "shop008",
        shopName: "sides & extras",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 61,
        name: "Sprite Lemon 35cl PET",
        category: "drinks",
        price: 1200,
        image: p61 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 62,
        name: "Sprite lemon 50cl PET",
        category: "drinks",
        price: 1500,
        image: p62 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 63,
        name: "Sweet Potato - Regular N3,200",
        category: "sides",
        price: 9600,
        image: p63 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 64,
        name: "Sweet Potato - Regular",
        category: "sides",
        price: 3500,
        image: p64 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 65,
        name: "The Beef Gourmet Meal ",
        category: "gourmet",
        price: 24000,
        image: p65 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 66,
        name: "The Beef Gourmet ",
        category: "gourmet",
        price: 19600,
        image: p66 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 67,
        name: "The Big Deal",
        category: "signature",
        price: 19500,
        image: p67 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 68,
        name: "The Big King Chicken Meal",
        category: "value",
        price: 12200,
        image: p68 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 69,
        name: "The Big King Chicken Meal - Medium",
        category: "classic",
        price: 10200,
        image: p69 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 70,
        name: "The Big King Meal - Regular",
        category: "classic",
        price: 9000,
        image: p70 ,
        shopId: "shop008",
        shopName: "Burger King",
        
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
      {
        id: 71,
        name: "The Big King Meal - Large",
        category: "classic",
        price: 12200,
        image: p71 ,
        shopId: "shop008",
        shopName: "Burger King",
          vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
      },
       
         {
          id: 72,
          name: "The Big King Meal - Medium",
          category: "classic",
          price: 10200,
          image: p72 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 73,
          name: "The Big King Meal - Regular",
          category: "classic",
          price: 9000,
          image: p73 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 74,
          name: "The Big King XXL Meal- Regular",
          category: "classic",
          price: 14750,
          image: p74 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 75,
          name: "The Chicken Gourmet Meal",
          category: "gourmet",
          price: 24000,
          image: p75 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 76,
          name: "The Chicken Gourmet",
          category: "gourmet",
          price: 19600,
          image: p76 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 77,
          name: "The Double Steakhouse Meal - Large",
          category: "signature",
          price: 16950,
          image: p77 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 78,
          name: "The Double Whopper Meal - Large",
          category: "classic",
          price: 14850,
          image: p78 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 79,
          name: "The Gourmet Fries",
          category: "gourmet",
          price: 16450,
          image: p79 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
    
        {
          id: 80,
          name: "The King Chicken Fillet Meal - Medium",
          category: "signature",
          price: 12550,
          image: p80 ,
          shopId: "shop008",
          shopName: "sides & extras",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 81,
          name: "The King Chicken Fillet",
          category: "signature",
          price: 9800,
          image: p81 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 82,
          name: "The Meat Lover Gourmet Meal",
          category: "gourmet",
          price: 24100,
          image: p82 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 83,
          name: "The Meat Lover Gourmet",
          category: "gourmet",
          price: 20700,
          image: p83 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 84,
          name: "The Steakhouse Meal - Large",
          category: "signature",
          price: 14750,
          image: p84 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 85,
          name: "The Steakhouse Meal - Medium",
          category: "signature",
          price: 14650,
          image: p85 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 86,
          name: "The Steakhouse",
          category: "signature",
          price: 10350,
          image: p86 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 87,
          name: "The Whopper Meal - Large",
          category: "classic",
          price: 12800,
          image: p87 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 88,
          name: "The Whopper Meal - Medium",
          category: "classic",
          price: 10700,
          image: p88 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 89,
          name: "The Whopper Meal - Regular",
          category: "value",
          price: 9600,
          image: p89 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 90,
          name: "The double Steakhouse Meal -Regular",
          category: "signature",
          price: 14750,
          image: p90 ,
          shopId: "shop008",
          shopName: "Burger King",
          
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
        {
          id: 91,
          name: "Whopper Junior Meal - Large",
          category: "classic",
          price: 9300,
          image: p91 ,
          shopId: "shop008",
          shopName: "Burger King",
            vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
        },
         
           {
            id: 92,
            name: "Whopper junior ",
            category: "classic",
            price: 5400,
            image: p92 ,
            shopId: "shop008",
            shopName: "Burger King",
            
              vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
          },
          {
            id: 93,
            name: "Yam Fries Large ",
            category: "sides",
            price: 3800,
            image: p93 ,
            shopId: "shop008",
            shopName: "Burger King",
            
              vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
          },
          {
            id: 94,
            name: "Yam Fries Regular",
            category: "sides",
            price: 3200,
            image: p94 ,
            shopId: "shop008",
            shopName: "Burger King",
            
              vendorId: "LOucNCi7PVNlv0la2c4NVh4fssC3"
          },
          
    

    
  ];
  
  export default products;

  